import { gql } from '@apollo/client';

export * from './escrowRemove.mutation.generated';

export const ESCROW_REMOVE = gql`
  mutation escrowRemove($escrowId: ID!) {
    escrowRemove(input: { escrowId: $escrowId }) {
      success
      errors
    }
  }
`;
